import { mockCmsImage } from '@domgen/dgx-fe-cms';
import { CmsHighlightedPartners } from '../../models/extra-appliance-details/cms-highlighted-partners.interface';

export const mockCmsHighlightedPartners: CmsHighlightedPartners = {
  highlightedPartnersTitle:
    'We also cover the following brands, and many more...',
  highlightedPartners: [mockCmsImage],
};
